import * as React from 'react';

import { FormField } from 'components/form';
import Input from 'components/inputs/input/Input';

import { __t, applyTranslations } from 'utils/language';

import './profile-artist-name.scss';

applyTranslations(require('./profile-artist-name.i18n.json'));

import type { InfluencerProfileForm } from 'types';

interface Props {
  profile: InfluencerProfileForm,
  onChange: (profile: Partial<InfluencerProfileForm>) => void
}

const MSG_KEY = 'profile_artist_name';

const ProfileArtistName: React.FC<Props> = ({
  profile,
  onChange
}) => {
  const handleChange = (
    event: React.SyntheticEvent<HTMLInputElement>
  ): void => {
    const target = event.currentTarget;

    onChange({
      [target.name]: target.value
    });
  };

  return (
    <div className="profile-artist-name">
      <FormField
        label={__t(`${MSG_KEY}.labels.artist_name`)}
        labelType="highlighted"
        direction="column"
        showValidationIcon={false}
        className="profile-artist-name__field"
        tooltipMessage={__t(`${MSG_KEY}.tooltips.artist_name`)}
        tooltipWidth="long"
        tooltipTextAlign="left"
      >
        <Input
          value={profile.artistName || ''}
          name="artistName"
          width="responsive"
          onChange={handleChange}
        />
      </FormField>
    </div>
  );
};

export default ProfileArtistName;
